import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx } from "vue"

import { computed } from 'vue'
import AppLayoutHeader from './AppLayoutHeader/AppLayoutHeader.vue'
import AppLayoutMobileSidebar from './AppLayoutMobileSidebar.vue'
import AppLayoutSidebar from './AppLayoutSidebar.vue'
import { useDevice } from '@/composables/useDevice'

import {
  hideMobileMenu,
  shouldRenderMobileMenu,
  shouldRenderFallbackHeader,
  enableShellHeader,
  showMobileMenu,
} from '@/components/orchestrated-layout'


export default /*#__PURE__*/_defineComponent({
  __name: 'AppLayoutDefault',
  setup(__props) {

const { device } = useDevice()

const isMobile = computed(() => device.value === 'mobile')

return (_ctx: any,_cache: any) => {
  const _component_orchestrated_layout = _resolveComponent("orchestrated-layout")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_dsf_page_layout = _resolveComponent("dsf-page-layout")!

  return (_openBlock(), _createBlock(_component_dsf_page_layout, null, {
    default: _withCtx(() => [
      (!isMobile.value)
        ? (_openBlock(), _createBlock(AppLayoutSidebar, {
            key: 0,
            slot: "menu",
            class: "dsf-hidden-mobile"
          }))
        : _createCommentVNode("v-if", true),
      (_unref(enableShellHeader) && _unref(shouldRenderFallbackHeader))
        ? (_openBlock(), _createBlock(_component_orchestrated_layout, {
            key: 1,
            fallback: true,
            slot: "navbar"
          }))
        : _createCommentVNode("v-if", true),
      (!_unref(enableShellHeader))
        ? (_openBlock(), _createBlock(AppLayoutHeader, {
            key: 2,
            slot: "navbar",
            class: "header",
            onMobileMenuClick: _unref(showMobileMenu)
          }, null, 8 /* PROPS */, ["onMobileMenuClick"]))
        : _createCommentVNode("v-if", true),
      (isMobile.value && _unref(shouldRenderMobileMenu))
        ? (_openBlock(), _createBlock(AppLayoutMobileSidebar, {
            key: 3,
            slot: "menu",
            onClose: _unref(hideMobileMenu),
            class: "dsf-hidden-tablet dsf-hidden-desktop z-[var(--dsf-z-index-layout)]"
          }, null, 8 /* PROPS */, ["onClose"]))
        : _createCommentVNode("v-if", true),
      _createVNode(_component_router_view, {
        slot: "content",
        class: "content",
        "data-test": "sennTMS-shell-content"
      })
    ]),
    _: 1 /* STABLE */
  }))
}
}

})